module.exports = __webpack_public_path__ + "static/media/SPC_01.78efcb3a.jpeg";